import { Container } from '@pixi/react'
import { Assets } from 'pixi.js'
import { Button, FeatureToggleType, soundManager, SoundType, useFeatureToggleStore } from '@slot-nx/core'
import { usePopupStore } from '../../domain/store/popupStore'

import btnBBNormal from '../../../asset/images/buyBonus/btn_bB_normal.png'
import btnBBHover from '../../../asset/images/buyBonus/btn_bB_hover.png'
import btnBBClick from '../../../asset/images/buyBonus/btn_bB_click.png'
import btnBBUnable from '../../../asset/images/buyBonus/btn_bB_unable.png'
import { useGameStore } from '../../domain/game/store/GameStore'
import { useSelector } from '@xstate/react'
import { GameState, sweetBombMachine } from '../../../machine/sweetbombMachine'
import { useMemo } from 'react'

Assets.addBundle('buyBonus', {
  btnBBNormal: { src: btnBBNormal, loadParser: 'loadTextures' },
  btnBBHover: { src: btnBBHover, loadParser: 'loadTextures' },
  btnBBClick: { src: btnBBClick, loadParser: 'loadTextures' },
  btnBBUnable: { src: btnBBUnable, loadParser: 'loadTextures' },
})

export const BuyBonus = () => {
  const width = 321
  const height = 174
  const isAnteBet = useGameStore(x => x.isAnteBet)
  const currentState = useSelector(sweetBombMachine, state => state)
  const { isFreeGame } = useGameStore()
  const featureToggle = useFeatureToggleStore(x => x.toggleList)
  const isDisableBuyBonus = !featureToggle.get(FeatureToggleType.disableBuyBonus)

  const isShowButton = useMemo(() => {
    return !isFreeGame && isDisableBuyBonus
  }, [isFreeGame, isDisableBuyBonus])

  return (
    <Container
      name="BuyBonus"
      x={120}
      y={850}
      width={width}
      height={height}
    >
      {
        isShowButton && (
          <Button
            name="buyBonus"
            x={0}
            y={0}
            width={width}
            height={height}
            enabled={!isAnteBet && currentState.matches(GameState.mainGame)}
            visible={true}
            defaultView="btnBBNormal"
            hoverView="btnBBHover"
            disabledView="btnBBUnable"
            pressedView="btnBBClick"
            onPress={() => {
              soundManager.play(SoundType.buttonConfirm)
              usePopupStore.setState({
                isOpenFreeGamePopup: true,
              })
            }}
          />
        )
      }
    </Container>
  )
}
